import { render } from "./MobileBar.vue?vue&type=template&id=6d5d7dd2"
import script from "./MobileBar.vue?vue&type=script&lang=js"
export * from "./MobileBar.vue?vue&type=script&lang=js"

import "./MobileBar.vue?vue&type=style&index=0&id=6d5d7dd2&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__